import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/platform/xdr')({
  head: () => ({
    ...buildSeoHead({ path: '/platform/xdr', ...ROUTE_META['/platform/xdr'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'XDR', path: '/platform/xdr' }])),
      jsonLdScript(buildWebPageSchema({ path: '/platform/xdr', ...ROUTE_META['/platform/xdr'] })),
    ],
  }),
});
